import {Alert, Box, Button, TextField} from '@mui/material';
import React, {useEffect, useState} from 'react';
import * as Sentry from '@sentry/react';
import {useTranslation} from 'react-i18next';
import {playsightMatchIdentifierRegex} from '../../../services/videoService';
import VideoTypeHeader from './VideoTypeHeader';
import {VideoTypes} from '../../../enums';
import AddVideoWrapper from './AddVideoWrapper';

interface Props {
  setShowModal: (showModal: boolean) => void;
  createSegment: (params: {
    fileName?: string;
    parts?: number;
    playsightUrl?: string;
  }) => object;
  processVideo: () => void;
  refresh: () => void;
}

const AddPlaysightVideo: React.FC<Props> = ({
  setShowModal,
  createSegment,
  processVideo,
  refresh,
}) => {
  const {t} = useTranslation();

  const [playsightUrl, setPlaysightUrl] = useState<string>('');
  const [isValidPlaysightUrl, setIsValidPlaysightUrl] =
    useState<boolean>(false);

  useEffect(() => {
    setIsValidPlaysightUrl(!!playsightMatchIdentifierRegex.exec(playsightUrl));
  }, [playsightUrl]);

  return (
    <AddVideoWrapper type={VideoTypes.playsight}>
      <VideoTypeHeader type={VideoTypes.playsight} />
      {playsightUrl.length > 0 && !isValidPlaysightUrl && (
        <Alert severity="error" variant="outlined" sx={{mb: 1}}>
          {t('video.videoTypes.playsight.invalidUrlError')}
        </Alert>
      )}
      <TextField
        label={t('video.playsightUrl')}
        sx={{width: '100%', mt: 3, mb: 3}}
        onChange={e => setPlaysightUrl(e.target.value)}
        value={playsightUrl}
      />
      <Box sx={{textAlign: 'right'}}>
        <Button
          variant="contained"
          disabled={!isValidPlaysightUrl}
          onClick={async () => {
            try {
              await createSegment({
                playsightUrl,
              });
            } catch (err) {
              console.error(err);
              Sentry.captureException(err);
              window.alert(t('video.addVideoFailed'));
              return;
            }
            await processVideo();
            await refresh();
            setShowModal(false);
          }}>
          {t('general.submit')}
        </Button>
      </Box>
    </AddVideoWrapper>
  );
};

export default AddPlaysightVideo;
